import { render, staticRenderFns } from "./ComplainDelete.vue?vue&type=template&id=6192d17e&"
import script from "./ComplainDelete.vue?vue&type=script&lang=js&"
export * from "./ComplainDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports